module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L76L78.65434a8f.jpg";